import React, {PureComponent, ReactNode} from "react";
import {GarageProfileHeroSlider} from "@App/components/GarageProfile/GaragProfileParts/GarageProfileHeroSlider";
// @ts-ignore
import {Garage, Image, PartnerConfig} from "@App/types";
import {GarageProfileMapProps} from "@App/components/GarageProfile/GaragProfileParts/GarageProfileMap";
import dynamic from 'next/dynamic'
import partner from "@App/pages/[partner]";

const GarageProfileMap = dynamic<GarageProfileMapProps>(() => import("@App/components/GarageProfile/GaragProfileParts/GarageProfileMap") as any, {ssr:false })


export type GarageProfileHeroProps = {
    garage: Garage
    partner: PartnerConfig
};

export class GarageProfileHero extends PureComponent<GarageProfileHeroProps> {

    render(): ReactNode {
        const {
            garage,
            partner
        } = this.props

        const images:Image[] = [
            {sizes: garage.cover_image_sizes},
            ...garage.images
        ]

        return (
            <div className={'garageProfile__hero col-span-full order-none lg:order-1 h-[218px] md:h-[320px]  grid grid-cols-2 gap-x-2 mb-6 lg:mb-12'}>
                <div className={'col-span-2 lg:col-span-1'}>
                    <GarageProfileHeroSlider images={garage ? images  : []} alt={garage ? garage.name : ''} id={garage.id} partner={partner} />
                </div>
                <div className={'hidden lg:block col-span-1'}>
                    <div className={'w-full h-full rounded-r-md'}>
                        <GarageProfileMap garage={garage}/>
                    </div>
                </div>
            </div>
        )
    }
}
